export default __webpack_public_path__ + "static/media/IDYM.0432b5f4.png";